import { useContext } from 'react';
import { AppContext } from 'commons-ui';
import { DETAIL_TYPE_BANK, DETAIL_TYPE_UPI } from '../constants';
import { UseContentParams } from '../../../../models/basicDetails.model';

const useContent = ({ setDownloadSection, downloadSectionRef, downloadUserPayoutDetails, uid }: UseContentParams) => {
	const { showAlert } = useContext(AppContext);

	const handleFormCancel = () => {
		setDownloadSection(null);
	};

	const handleFormSubmit = async (ticketId: string, description: string) => {
		if (!downloadSectionRef.current) {
			return;
		}
		try {
			await downloadUserPayoutDetails({
				userId: uid,
				section: downloadSectionRef.current,
				ticketId,
				description
			});
			setDownloadSection(null);
		} catch (error) {
			const errorMessage = error instanceof Error ? error.message : 'Failed to download payout details. Please try again.';
			showAlert(errorMessage, { type: 'error' });
		}
	};

	const handleDownloadClick = (section: typeof DETAIL_TYPE_BANK | typeof DETAIL_TYPE_UPI) => {
		setDownloadSection(section);
	};

	return {
		handleFormCancel,
		handleFormSubmit,
		handleDownloadClick
	};
};

export default useContent;
